// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* colors */
/* 
  mixin for multiline ellipsis
  http://hackingui.com/front-end/a-pure-css-solution-for-multiline-text-truncation/
*/
.admin-nav {
  padding: 10px 0px;
  display: inline-block;
  width: 100%;
}
.admin-nav .rightHandNavBtns {
  display: inline;
  float: right;
}
.admin-nav .rightHandNavBtns .adminAddBtn {
  color: white;
}
.admin-nav .btn-link {
  color: #495057;
  text-decoration: none;
}
.admin-nav .btn-link:hover {
  text-decoration: underline;
}
.admin-nav .btn-link.active {
  font-weight: bold;
}

.showErrorBorder {
  border: 1px solid #dc3545;
}

.modal-body {
  width: 400px;
}
.modal-body #userForm label,
.modal-body #addNewGroupsForm label,
.modal-body #addroleForm label {
  display: block;
}
.modal-body #userForm input,
.modal-body #userForm select,
.modal-body #addNewGroupsForm input,
.modal-body #addNewGroupsForm select,
.modal-body #addroleForm input,
.modal-body #addroleForm select {
  margin-bottom: 1rem;
  width: 100%;
  line-height: 2rem;
  padding-left: 1rem;
  padding-right: 1rem;
  font-size: 1rem;
}

.groupSelector,
.roleSelector {
  margin-bottom: 1rem;
}

.btn-link.active {
  font-weight: bold;
}

.adminSearchFieldContainer {
  position: relative;
}
.adminSearchFieldContainer input {
  margin-bottom: 1rem;
  width: 100%;
  line-height: 2rem;
  padding-left: 1rem;
  padding-right: 2rem;
  font-size: 1rem;
  border-radius: 0;
  border-style: solid;
  border-width: 1px;
  border-color: #e0e0e0;
}
.adminSearchFieldContainer #adminSearchIcon {
  height: 1rem;
  position: absolute;
  display: block;
  top: 0.75rem;
  right: 0.75rem;
  fill: #6c757d;
  color: #6c757d;
}

.edocs-alias {
  font-weight: bold;
  font-size: 8.5714px;
  font-size: 0.85714rem;
}
.edocs-alias.red {
  color: #dc3545;
}
.edocs-alias.green {
  color: #28a745;
}

.e-flmenu.e-control.e-dialog.e-lib.e-filter-popup.e-popup.e-popup-open {
  display: none;
}

.customFilterHiddenInput {
  height: 1px;
  opacity: 0;
  width: 1px;
}

.customFilterRecord {
  cursor: pointer;
}

.noFilterReturnedResults {
  height: 60px;
  padding: 23px;
  text-align: center;
}

.e-checkbox-wrapper {
  display: flex;
}`, "",{"version":3,"sources":["webpack://./src/scss/_variables.scss","webpack://./src/scss/_mixins.scss","webpack://./src/app/containers/admin/admin.component.scss","webpack://./../../../../../RAP%20(.NET%2010)/RAP%20-%20UAT%20(.NET%2010)/rap/RAP/ClientApp/src/app/containers/admin/admin.component.scss"],"names":[],"mappings":"AAAA,WAAA;ACaA;;;CAAA;ACVA;EACE,iBAAA;EACA,qBAAA;EACA,WAAA;ACGF;ADDE;EACE,eAAA;EACA,YAAA;ACGJ;ADDI;EACE,YAAA;ACGN;ADCE;EACE,cAAA;EACA,qBAAA;ACCJ;ADAI;EACE,0BAAA;ACEN;ADAI;EACE,iBAAA;ACEN;;ADGA;EACE,yBAAA;ACAF;;ADGA;EACE,YAAA;ACAF;ADKI;;;EACE,cAAA;ACDN;ADII;;;;;;EAEE,mBAAA;EACA,WAAA;EACA,iBAAA;EACA,kBAAA;EACA,mBAAA;EACA,eAAA;ACEN;;ADOA;;EAEE,mBAAA;ACJF;;ADQE;EACE,iBAAA;ACLJ;;ADSA;EACE,kBAAA;ACNF;ADQE;EACE,mBAAA;EACA,WAAA;EACA,iBAAA;EACA,kBAAA;EACA,mBAAA;EACA,eAAA;EAEA,gBAAA;EACA,mBAAA;EACA,iBAAA;EACA,qBAAA;ACPJ;ADUE;EACE,YAAA;EACA,kBAAA;EACA,cAAA;EACA,YAAA;EACA,cAAA;EACA,aAAA;EACA,cAAA;ACRJ;;ADYA;EACE,iBAAA;EDlGA,mBAAA;EACA,qBAAA;AE0FF;ADSE;EACE,cFnGE;AG4FN;ADSE;EACE,cFjFG;AG0EP;;ADWA;EACE,aAAA;ACRF;;ADWA;EACE,WAAA;EACA,UAAA;EACA,UAAA;ACRF;;ADWA;EACE,eAAA;ACRF;;ADWA;EACE,YAAA;EACA,aAAA;EACA,kBAAA;ACRF;;ADWA;EACE,aAAA;ACRF","sourcesContent":["/* colors */\r\n$white: #ffffff;\r\n$black: #000000;\r\n$red: #dc3545;\r\n$header-bg: rgba(18, 77, 97, 0.93);\r\n$nav-item-active: rgba(255, 255, 255, 0.1);\r\n$btn-primary: #166079;\r\n$btn-primary-disabled: #2f4f4f;\r\n$btn-primary-hover: #0e3e4e;\r\n\r\n$btn-primary-danger: #a01f2b;\r\n$btn-primary-danger-disabled: #5d3539;\r\n$btn-primary-danger-hover: #77121c;\r\n\r\n$error: $red;\r\n\r\n$details-value: #555555;\r\n$dnvLake: #6399ae;\r\n$dnv-blue: #166079;\r\n\r\n// $hold: $yellow;\r\n// $open: $green;\r\n// $inprogress: #1887ab;\r\n$hold: #ffc107;\r\n$open: #28a745;\r\n$closed: $black;\r\n$inprogress: #235a6c;\r\n\r\n$fontAvenir: \"Avenir LT Std\", Arial, sans-serif;\r\n\r\n$line-height: 1.5em;\r\n\r\n$search-page-media-max: 840px;\r\n$search-page-media-min: 841px;\r\n","@mixin font-size($sizeValue: 1.6) {\r\n  font-size: ($sizeValue * 10) + px;\r\n  font-size: $sizeValue + rem;\r\n}\r\n\r\n@mixin clearfix {\r\n  &:after {\r\n    content: \"\";\r\n    display: table;\r\n    clear: both;\r\n  }\r\n}\r\n\r\n/* \r\n  mixin for multiline ellipsis\r\n  http://hackingui.com/front-end/a-pure-css-solution-for-multiline-text-truncation/\r\n*/\r\n@mixin multiLineEllipsis($lineHeight: 1.2em, $lineCount: 1, $bgColor:  $white){\r\n  overflow: hidden;\r\n  position: relative;\r\n  line-height: $lineHeight;\r\n  max-height: $lineHeight * $lineCount; \r\n  text-align: justify;\r\n  /*margin-right: -1em;*/\r\n  padding-right: 1em;\r\n  &:before {\r\n    content: '...';\r\n    position: absolute;\r\n    right: 1px;\r\n    bottom: 0;\r\n  }\r\n  &:after {\r\n    content: '';\r\n    position: absolute;\r\n    right: 0;\r\n    width: 1em;\r\n    height: 1em;\r\n    margin-top: 0.2em;\r\n    background: $bgColor;\r\n  }\r\n}","@use \"../../../scss/variables\" as v;\r\n@use \"../../../scss/_mixins\" as mx;\r\n\r\n.admin-nav {\r\n  padding: 10px 0px;\r\n  display: inline-block;\r\n  width: 100%;\r\n\r\n  .rightHandNavBtns {\r\n    display: inline;\r\n    float: right;\r\n\r\n    .adminAddBtn {\r\n      color: white;\r\n    }\r\n  }\r\n\r\n  .btn-link{\r\n    color: #495057;\r\n    text-decoration: none;\r\n    &:hover{\r\n      text-decoration: underline;\r\n    } \r\n    &.active{\r\n      font-weight: bold;\r\n    }\r\n  }\r\n}\r\n\r\n.showErrorBorder {\r\n  border: 1px solid v.$red;\r\n}\r\n\r\n.modal-body {\r\n  width: 400px;\r\n\r\n  #userForm,\r\n  #addNewGroupsForm,\r\n  #addroleForm {\r\n    label {\r\n      display: block;\r\n    }\r\n\r\n    input,\r\n    select {\r\n      margin-bottom: 1rem;\r\n      width: 100%;\r\n      line-height: 2rem;\r\n      padding-left: 1rem;\r\n      padding-right: 1rem;\r\n      font-size: 1rem;\r\n    }\r\n\r\n    // select {\r\n    //   height: 2rem;\r\n    // }\r\n  }\r\n}\r\n\r\n.groupSelector,\r\n.roleSelector {\r\n  margin-bottom: 1rem;\r\n}\r\n\r\n.btn-link {\r\n  &.active {\r\n    font-weight: bold;\r\n  }\r\n}\r\n\r\n.adminSearchFieldContainer {\r\n  position: relative;\r\n\r\n  input {\r\n    margin-bottom: 1rem;\r\n    width: 100%;\r\n    line-height: 2rem;\r\n    padding-left: 1rem;\r\n    padding-right: 2rem;\r\n    font-size: 1rem;\r\n\r\n    border-radius: 0;\r\n    border-style: solid;\r\n    border-width: 1px;\r\n    border-color: #e0e0e0;\r\n  }\r\n\r\n  #adminSearchIcon {\r\n    height: 1rem;\r\n    position: absolute;\r\n    display: block;\r\n    top: 0.75rem;\r\n    right: 0.75rem;\r\n    fill: #6c757d;\r\n    color: #6c757d;\r\n  }\r\n}\r\n\r\n.edocs-alias {\r\n  font-weight: bold;\r\n  @include mx.font-size(0.85714);\r\n  &.red {\r\n    color: v.$red;\r\n  }\r\n  &.green {\r\n    color: v.$open;\r\n  }\r\n}\r\n\r\n.e-flmenu.e-control.e-dialog.e-lib.e-filter-popup.e-popup.e-popup-open {\r\n  display: none;\r\n}\r\n\r\n.customFilterHiddenInput {\r\n  height: 1px;\r\n  opacity: 0;\r\n  width: 1px;\r\n}\r\n\r\n.customFilterRecord {\r\n  cursor: pointer;\r\n}\r\n\r\n.noFilterReturnedResults {\r\n  height: 60px;\r\n  padding: 23px;\r\n  text-align: center;\r\n}\r\n\r\n.e-checkbox-wrapper {\r\n  display: flex;\r\n}\r\n","/* colors */\n/* \n  mixin for multiline ellipsis\n  http://hackingui.com/front-end/a-pure-css-solution-for-multiline-text-truncation/\n*/\n.admin-nav {\n  padding: 10px 0px;\n  display: inline-block;\n  width: 100%;\n}\n.admin-nav .rightHandNavBtns {\n  display: inline;\n  float: right;\n}\n.admin-nav .rightHandNavBtns .adminAddBtn {\n  color: white;\n}\n.admin-nav .btn-link {\n  color: #495057;\n  text-decoration: none;\n}\n.admin-nav .btn-link:hover {\n  text-decoration: underline;\n}\n.admin-nav .btn-link.active {\n  font-weight: bold;\n}\n\n.showErrorBorder {\n  border: 1px solid #dc3545;\n}\n\n.modal-body {\n  width: 400px;\n}\n.modal-body #userForm label,\n.modal-body #addNewGroupsForm label,\n.modal-body #addroleForm label {\n  display: block;\n}\n.modal-body #userForm input,\n.modal-body #userForm select,\n.modal-body #addNewGroupsForm input,\n.modal-body #addNewGroupsForm select,\n.modal-body #addroleForm input,\n.modal-body #addroleForm select {\n  margin-bottom: 1rem;\n  width: 100%;\n  line-height: 2rem;\n  padding-left: 1rem;\n  padding-right: 1rem;\n  font-size: 1rem;\n}\n\n.groupSelector,\n.roleSelector {\n  margin-bottom: 1rem;\n}\n\n.btn-link.active {\n  font-weight: bold;\n}\n\n.adminSearchFieldContainer {\n  position: relative;\n}\n.adminSearchFieldContainer input {\n  margin-bottom: 1rem;\n  width: 100%;\n  line-height: 2rem;\n  padding-left: 1rem;\n  padding-right: 2rem;\n  font-size: 1rem;\n  border-radius: 0;\n  border-style: solid;\n  border-width: 1px;\n  border-color: #e0e0e0;\n}\n.adminSearchFieldContainer #adminSearchIcon {\n  height: 1rem;\n  position: absolute;\n  display: block;\n  top: 0.75rem;\n  right: 0.75rem;\n  fill: #6c757d;\n  color: #6c757d;\n}\n\n.edocs-alias {\n  font-weight: bold;\n  font-size: 8.5714px;\n  font-size: 0.85714rem;\n}\n.edocs-alias.red {\n  color: #dc3545;\n}\n.edocs-alias.green {\n  color: #28a745;\n}\n\n.e-flmenu.e-control.e-dialog.e-lib.e-filter-popup.e-popup.e-popup-open {\n  display: none;\n}\n\n.customFilterHiddenInput {\n  height: 1px;\n  opacity: 0;\n  width: 1px;\n}\n\n.customFilterRecord {\n  cursor: pointer;\n}\n\n.noFilterReturnedResults {\n  height: 60px;\n  padding: 23px;\n  text-align: center;\n}\n\n.e-checkbox-wrapper {\n  display: flex;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
